import "./Footer.css";
import logo from "../Assets/ritu broadband.png";
import { Link } from "react-router-dom";
import { Phone, Mail, MapPin } from "lucide-react";

function Footer() {
    return (
        <footer className="footer-root">
            <div className="footer-container">
                <div className="footer-grid">

                    {/* Col 1: Brand & About */}
                    <div className="footer-col footer-col-brand">
                        <div className="footer-logo">
                            <img src={logo} alt="Ritu Broadband" />
                        </div>
                        <p className="footer-brand-desc">
                            Your trusted Digital TV &amp; High-Speed Fiber Internet service provider in Achampet. Delivering speeds up to 200 Mbps &amp; 300+ Live Channels.
                        </p>
                        <div className="footer-social-icons">
                            <a href="#" aria-label="Facebook"><i className="fa-brands fa-facebook-f"></i></a>
                            <a href="#" aria-label="Twitter"><i className="fa-brands fa-x-twitter"></i></a>
                            <a href="#" aria-label="Instagram"><i className="fa-brands fa-instagram"></i></a>
                            <a href="#" aria-label="YouTube"><i className="fa-brands fa-youtube"></i></a>
                            <a href="https://wa.me/8555857585" target="_blank" rel="noopener noreferrer" aria-label="WhatsApp"><i className="fa-brands fa-whatsapp"></i></a>
                        </div>
                    </div>

                    {/* Col 2: Quick Links */}
                    <div className="footer-col">
                        <h4 className="footer-col-title">Quick Links</h4>
                        <ul className="footer-links-list">
                            <li><Link to="/">Home</Link></li>
                            <li><Link to="/about">About Us</Link></li>
                            <li><Link to="/plans">Plans &amp; Pricing</Link></li>
                            <li><Link to="/terms-and-conditions">Terms &amp; Conditions</Link></li>
                        </ul>
                    </div>

                    {/* Col 3: Contact Info */}
                    <div className="footer-col">
                        <h4 className="footer-col-title">Contact Support</h4>
                        <ul className="footer-contact-list">
                            <li>
                                <Phone size={16} className="footer-icon" />
                                <div>
                                    <span className="contact-lbl">Phone Numbers</span>
                                    <a href="tel:7702935830">+91 7702935830</a>, <a href="tel:8500168970">+91 8500168970</a>
                                </div>
                            </li>
                            <li>
                                <Mail size={16} className="footer-icon" />
                                <div>
                                    <span className="contact-lbl">Email Address</span>
                                    <a href="mailto:ritubroadband123@gmail.com">ritubroadband123@gmail.com</a>
                                </div>
                            </li>
                        </ul>
                    </div>

                    {/* Col 4: Business Address */}
                    <div className="footer-col">
                        <h4 className="footer-col-title">Business Address</h4>
                        <div className="footer-address-card">
                            <div className="address-header">
                                <MapPin size={18} className="address-icon" />
                                <strong>Ritu Broadband</strong>
                            </div>
                            <p>Plot No. 20-80/A</p>
                            <p>Opposite New Bus Stand</p>
                            <p>Ar Reddy Chicken Center</p>
                            <p>Billing – 1st Floor, Achampet</p>
                        </div>
                    </div>

                </div>

                {/* Bottom Bar */}
                <div className="footer-bottom">
                    <div className="footer-bottom-info">
                        <p>*<Link to="/terms-and-conditions">Terms &amp; Conditions</Link> apply. Free to Use ONT (WiFi Router) - GST Extra applies. Netflix and other OTT platforms available with select plans.</p>
                        <p>© 2026 Ritu Broadband, Achampet. All Rights Reserved.</p>
                    </div>
                </div>
            </div>
        </footer>
    );
}

export default Footer;
